import { Component, OnInit, ViewChild } from '@angular/core';
import { ReminderAndEscalationService } from '../services/reminder-and-escalation.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { MatPaginator } from '@angular/material/paginator';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-reminder-and-escalation',
  templateUrl: './reminder-and-escalation.component.html',
  styleUrls: ['./reminder-and-escalation.component.css']
})
export class ReminderAndEscalationComponent implements OnInit {
  displayedColumns: string[] = [
    'employeeId',
    'firstName',
    'lastName',
    'emailAddress',
    'level',
    'remindedDate',
    'organizationCode',
    'updatedStatus',
    'updatedOn'
  ];
  selectedLevels: number[] = [];
  orgOptions: any[] = [];
  selectedOrgCodes: string[] = [];
  exportDataAvailable: boolean = false;

  levelOptions = [
    { value: 1, label: 'Reminder 1', checked: false },
    { value: 2, label: 'Reminder 2', checked: false },
    { value: 3, label: 'Reminder 3', checked: false },
    { value: 4, label: 'Reminder 4', checked: false },
    { value: 5, label: 'Escalation', checked: false },
    { value: 6, label: 'Friendly Reminder', checked: false }
  ];
  updatedStatusOptions = [
  { value: 'Updated', label: 'Updated', checked: false },
  { value: 'Not Updated', label: 'Not Updated', checked: false }
 ];
selectedStatuses: string[] = [];
  data: any[] = [];
  totalRecords = 0;
  pageSize = 10;
  pageIndex = 0;

  searchText = '';
  levelFilter: number | null = null;
  orgCodeFilter: string = '';
  isLoading = true;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private reminderService: ReminderAndEscalationService,        
     private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.loadOrgCodes();
    this.loadData();
  }

  loadOrgCodes() {
    this.reminderService.getOrganizationCodes().subscribe((codes: any[]) => {
      this.orgOptions = codes.map(code => ({
        label: code,
        checked: false
      }));
    });
  }

  loadData(): void {
    this.isLoading = true;
    const from = this.pageIndex * this.pageSize;
    const orgCodesString = this.selectedOrgCodes.join(',');
    this.reminderService.getReminderAndEscalationDataBySearch(this.searchText, from, this.pageSize, this.selectedLevels, orgCodesString, this.selectedStatuses).subscribe(response => {
      if (response) {
        this.data = response.reminderAndEscalationResponse;
        this.totalRecords = response.total;
      } else {
        this.data = response || [];
      }
      this.isLoading = false;
    });
  }

  onSearch(): void {
    this.pageIndex = 0;
    if (this.paginator) this.paginator.firstPage();
    this.loadData();
  }

  onPageChange(event: any): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadData();
  }

  applyLevelFilter() {
    this.selectedLevels = this.levelOptions
      .filter(l => l.checked)
      .map(l => l.value);

    this.pageIndex = 0;
    if (this.paginator) this.paginator.firstPage();
    this.loadData();
  }
  cancelLevelFilter() {
    this.levelOptions.forEach(l => l.checked = false);
    this.selectedLevels = [];
    this.levelFilter = null;
    this.pageIndex = 0;
    if (this.paginator) this.paginator.firstPage();
    this.loadData();
  }

  applyOrgFilter() {
    this.selectedOrgCodes = this.orgOptions
      .filter(opt => opt.checked)
      .map(opt => opt.label ?? "NA");

    this.pageIndex = 0;
    if (this.paginator) this.paginator.firstPage();
    this.loadData();
  }

  cancelOrgFilter() {
    this.orgOptions.forEach(l => l.checked = false);
    this.selectedOrgCodes = [];
    this.pageIndex = 0;
    if (this.paginator) this.paginator.firstPage();
    this.loadData();
  }

  exportToExcel(): void {
    this.reminderService.exportReminderAndEscalationData(this.searchText, this.selectedLevels, this.selectedOrgCodes, this.selectedStatuses).subscribe(data => {
    this.exportDataAvailable = data && data.length > 0;

  if (!this.exportDataAvailable) {
    // message like "No data to export"
    this.toastr.info("No data available to export");
    return;
  }
      const getLevelLabel = (value) => {
        const option = this.levelOptions.find(opt => opt.value === value);
        return option ? option.label : value;
      };

      const exportData = data.map(item => ({
        'Employee ID': `${item.employeeId}`,
        'First Name': item.firstName,
        'Last Name': item.lastName,
        'Email': item.emailAddress,
        'Level': ` ${getLevelLabel(item.level)}`,
        'Reminded Date': new Date(item.remindedDate).toLocaleDateString(),
        'Organization Code': item.organizationCode ? item.organizationCode : 'Not Available',
        'Updated Status': item.updatedStatus,
        'Updated On': item.updatedOn ? new Date(item.updatedOn).toLocaleDateString() : '',
      }));

      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
      const workbook: XLSX.WorkBook = { Sheets: { 'ReminderData': worksheet }, SheetNames: ['ReminderData'] };
      const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const blob: Blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      FileSaver.saveAs(blob, `ReminderData-${new Date().getTime()}.xlsx`);
    });
  }

  applyFilter(filterValue: string) {
    if (filterValue.length > 2 || filterValue.length === 0) {
      if (filterValue.includes('@')) {
        filterValue = filterValue.substring(0, filterValue.indexOf("@"));
      }
      this.searchText = filterValue;
      this.pageIndex = 0;
      if (this.paginator) this.paginator.firstPage();
      this.loadData();
    }
  }

  getReminderLabel(level: number): string {
    if (level === 1) return 'Reminder 1';
    if (level === 2) return 'Reminder 2';
    if (level === 3) return 'Reminder 3';
    if (level === 4) return 'Reminder 4';
    if (level === 5) return 'Escalation';
    if (level >= 6) return 'Friendly Reminder';
    return '';
  }

  clearSearch(): void {
    this.searchText = '';
    this.applyFilter('');
    if (this.paginator) this.paginator.firstPage();
  }

  getPaginatorData(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadData();
  }

  applyStatusFilter() {
  this.selectedStatuses = this.updatedStatusOptions
    .filter(opt => opt.checked)
    .map(opt => opt.value);

  this.pageIndex = 0;
  if (this.paginator) this.paginator.firstPage();
  setTimeout(() => {
    this.loadData();
  });
}

cancelStatusFilter() {
  this.updatedStatusOptions.forEach(opt => opt.checked = false);
  this.selectedStatuses = [];
  this.pageIndex = 0;
  if (this.paginator) this.paginator.firstPage();
  this.loadData();
}

}
